export const SportAssociationMap = new Map<string, string>([
  ["LSB", "820012"],
  ["SSB_POTSDAM", "820054"],
]);

export const SportAssociationNumberOf = (key: string): string => {
  return SportAssociationMap.get(key) ?? "";
};
